export function showAmount(privacyLevel:number,amount: number) :string{
    if (privacyLevel!==2) return '***';
    let res = amount<0?'***':(amount/(10_000_000)).toFixed(7)
    // remove suffix 0
    res = res.replace(/0+$/, '');

    if (res.endsWith('.')) {
        res = res.slice(0, -1);
    }
    return res;
}